var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{staticClass:"app-status-update-button",attrs:{"data-id":_vm.id,"colour":_vm.colour},on:{"onClick":_vm.onClick},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v(" "+_vm._s(_vm.buttonText)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }